import { ca } from '@cian/analytics';
import { getProductsData } from '../../selectors/analytics/builder';
import { EGenplanControlsType } from '../../types/analytics';

export function trackShowGenplan() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'show_sopr',
    label: 'building_plan',
    useLastProducts: true,
  });
}

export function trackHouseHover(newbuildingId: number, houseId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Hover',
    label: 'building_plan_corpus',
    products: [getProductsData(newbuildingId, null, { corpus_id: houseId })],
  });
}

export function trackHouseLinkClick(newbuildingId: number, houseId: number, rooms?: string) {
  const roomLabel = rooms ? rooms.toString() : 'all';

  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_developersFlats',
    label: 'from_select_corpus',
    products: [getProductsData(newbuildingId, null, { room_num: roomLabel, corpus_id: houseId })],
  });
}

export function trackGenplanEscrowLabelClick(newbuildingId: number, houseId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'building_plan_escrow',
    products: [getProductsData(newbuildingId, null, { corpus_id: houseId })],
  });
}

export function trackGenplanFlatsOnFloorClick(newbuildingId: number, houseId?: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'building_plan_flats_on_floor',
    products: [getProductsData(newbuildingId, null, { corpus_id: houseId })],
  });
}

export function trackGenplanControlsClick(newbuildingId: number, type: EGenplanControlsType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'building_plan_main',
    products: [getProductsData(newbuildingId, null, { type })],
  });
}
